import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { Utente } from '../_models/utente';
import { ServicesConstants } from '../services-constants';
import { HttpErrorResponse } from '@angular/common/http';

export abstract class ComponentBaseService {

  abstract getServiceName(): string;

  protected httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  protected handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      //console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Mando l'errore all'app per visualizzare un messaggio a video
      return Observable.throw(error);
      //return of(result as T);
    };
  }

  /** Log a UtenteService message with the MessageService */
  protected log(message: string) {
    //this.messageService.add('UtenteService: ' + message);
	  console.log(this.getServiceName() + ': ' + message);
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/component-base.service.ts